module.exports = __webpack_public_path__ + "static/media/nl.853e349a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/localised-handheld-phones/nl.png
// module id = 281
// module chunks = 0